import React from "react";
import { useSelector } from "react-redux";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import "swiper/css";

import PopularCard from "../../../components/landing/Popular/card";
import CardShimmer from "../../../components/landing/Popular/card-shimmer";

const Index = () => {
  const movieState = useSelector((state) => state.movieState);
  let shimmer = [0, 1, 2];
  return (
    <>
      <div>
        <div className="items-center text-center lg:mb-10">
          <h1 className="text-3xl lg:text-5xl text-slate-700 font-bold mb-4 lg:leading-[72px]">
            10 Most Popular Movies this Week
          </h1>
          <p className="text-base lg:text-lg text-slate-500 font-normal">
            Discover the top, most popular movies available now! Across
            theaters, streaming, and on-demand.
          </p>
        </div>
        <Swiper
          className="relative !pt-8 !pb-16 !overflow-auto !overflow-y-hidden"
          spaceBetween={24}
          slidesPerView={2}
          breakpoints={{
            // when window width is >= 320px
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 2,
              spaceBetween: 21,
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 2,
              spaceBetween: 21,
            },
            // when window width is >= 1024px
            1024: {
              slidesPerView: 2,
              spaceBetween: 21,
            },
            // when window width is >= 1440px
            1440: {
              slidesPerView: 3,
              spaceBetween: 21,
            },
          }}
        >
          {movieState.loading
            ? shimmer.map((item, index) => (
                <SwiperSlide key={index}>
                  <CardShimmer />
                </SwiperSlide>
              ))
            : movieState.error
            ? shimmer.map((item, index) => (
                <SwiperSlide key={index}>
                  <CardShimmer />
                </SwiperSlide>
              ))
            : movieState.movie.data &&
              movieState.movie.data.map((movie) => (
                <SwiperSlide key={movie.id}>
                  <PopularCard data={movie} />
                </SwiperSlide>
              ))}
        </Swiper>
      </div>
    </>
  );
};

export default Index;
